import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnonymousSearchComponent } from './components/anonymous-search/anonymous-search.component';
import { EnaioDocumentsDefinitionComponent } from './components/enaio-documents-definition/enaio-documents-definition.component';
import { EnaioDocumentsMainComponent } from './components/enaio-documents-main/enaio-documents-main.component';
import { Config } from '../app-template/models/config.model';

const routes: Routes = [
    {
        path: 'home',
        component: EnaioDocumentsMainComponent,
        canActivate: [() => Config.get().isModuleConfigured("EnaioDocumentsModule")]
    },
    {
        path: 'definition/:defId',
        redirectTo: 'definition/:defId/0',
        pathMatch: 'full'
    },
    {
        path: 'definition/:defId/:parentId',
        component: EnaioDocumentsDefinitionComponent,
        canActivate: [() => Config.get().isModuleConfigured("EnaioDocumentsModule")]
    },
    {
        path: 'as/:defId',
        component: AnonymousSearchComponent,
        canActivate: [() => Config.get().isModuleConfigured("EnaioDocumentsModule")]
    },
    {
        path: 'as/:defId/:searchString',
        component: AnonymousSearchComponent,
        canActivate: [() => Config.get().isModuleConfigured("EnaioDocumentsModule")]
    },
    {
        path: 'definition/as/:defId/:anonymousGuid',
        component: EnaioDocumentsDefinitionComponent,
        canActivate: [() => Config.get().isModuleConfigured("EnaioDocumentsModule")]
    },
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    }    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EnaioDocumentsRoutingModule {
}